/**
 * 首页数据以及全局数据的 - api
 * date:2022 07 06
 * author:brian
 */

import httpRequest from '@/utils/request.js'

/** 获取载体列表 */
export const mapTrackLst = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/mapTrack/lst',
    params: {
      ...params
    }
  })
/** 获取载体列表 */
// export const mapTrackGetCarrierInfo = (params = {}) =>
//     httpRequest.httpGet({
//         url: '/service/mapTrack/getCarrierInfo',
//         params: {
//             ...params
//         }
//     });
/** 地图单元与监测点位置显示 */
export const mapTrackPosition = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/mapTrack/position',
    params: {
      ...params
    }
  })

/** 地图单元详细内容点击监测点显示详细 */
export const mapTrackcarrierProbeState = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/mapTrack/carrierProbeState',
    params: {
      ...params
    }
  })
/** 点击车辆获取的跟踪信息 */
export const mapTrackcarrierTraceState = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/mapTrack/carrierTraceState',
    params: {
      ...params
    }
  })
/** 监测点追踪历史轨迹查询 */
export const mapTrackcarrierTrace = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/mapTrack/carrierTrace',
    params: {
      ...params
    }
  })
/** 点击监测点历史追踪轨迹点详细内容 */
export const mapTrackTraceDetail = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/mapTrack/traceDetail',
    params: {
      ...params
    }
  })

/** 获取客户详细接口 */
export const customerDetail = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/customer/detail',
    params: {
      ...params
    }
  })
/** 获取客户中心点 */
export const mapTrackGetScopeCenter = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/mapTrack/getScopeCenter',
    params: {
      ...params
    }
  })

/**
 * 获取实时轨迹
 * @param carrierId
 * @returns {Promise | Promise<unknown>}
 */
export const getRealtimeTrack = (carrierId) => httpRequest.httpGet({
  url: '/service/trans/track/current',
  params: {
    carrierId
  }
})
